<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {

    data() {
        return {
            loadingupload: false,
            messageBag:false,
            country_id_: '',
            staticURLDownload: process.env.VUE_APP_API_BASEURL,
        }
    },

    props: {
        order_id :{
            type : Number,
        },
        invoice_tax_file :{
            type : String,
        },
        jompay_file :{
            type : String,
        },
    },

    methods: {

        submitFile() {
            
            this.loadingupload = true;
            
            const formData = new FormData();
            if(this.Images1){
                formData.append('tax', this.Images1);
            }

            if(this.Images2){
                formData.append('jompay', this.Images2);
            }
            formData.append('order_id', this.order_id);

            const headers = { 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin':'*' };
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'order/invoice', formData, 
                { headers }
            ).then((res) => {
                    this.DevicesUpload ='';
                    
                    this.loadingupload= false;
                    

                    if(res.data.status=='error'){
                        this.messageBag = res.data.msj;
                        this.loadingupload = false;
                    }else{
                        this.messageBag=false;
                        this.$refs.btnscloseuploadqc.click();
                        
                        this.msjepopup();
                        
                    }
                    this.LoadingUploadSeen=false;
                }
            );
        },

        msjepopup(){
            Swal.fire({
                title: "File has been successfully updated",
                icon: "success",
                // showCancelButton: true,
                confirmButtonColor: "#34c38f",
                // cancelButtonColor: "#34c38f",
                // confirmButtonText: "Yes, Delete Device",
            }).then((result) => {
                if (result.value) {
                    window.location.reload();
                    // this.$router.push({
                    //         path: '/order/po/'+this.order_id
                    // });
                }
            });
        },

        tax() {
            this.Images1 = this.$refs.tax.files[0];
        },

        jompay() {
            this.Images2 = this.$refs.jompay.files[0];
        },

       myProfile(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'user/my')
            .then(response => {
                if (response) {
                    this.country_id_ = response.data.country_id;
                } else {

                    this.messageBag = ['No record.'];
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
        },
    },

    mounted() {     
        this.myProfile();   
    }
}
</script>
<template>
    <Layout>
        <div class="modal fade bs-example-modal-lg editRole" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" id="uploadQC">
                    <div class="modal-header">
                        <h5 class="modal-title" id="myLargeModalLabel">Upload File</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" id="padammodal" aria-label="Close" ref='btnscloseuploadqc'></button>
                    </div>
                    <div class="modal-body">
                        <p><strong>Tax Invoice</strong></p>
                        <input class="form-control" type="file" @change="tax" ref="tax" >
                        <p v-if="invoice_tax_file == '' || invoice_tax_file== NULL"></p>
                        <p v-else> <a :href="invoice_tax_file" target="_blank">View Tax Invoice</a></p>
                        <br>
                        <span v-if='country_id_ == 1'>
                            <p ><strong>JomPay Bill (Applicable for Maxis customer only)</strong><i v-b-tooltip.hover title="<img width=500 src='https://i.imgur.com/HeZtJ57.png' />" class="ri-information-fill"></i></p>
                            <input class="form-control" type="file" @change="jompay" ref="jompay" >
                            <p v-if="jompay_file == '' || jompay_file== NULL"></p>
                            <p v-else><a :href="jompay_file" target="_blank" >View Jompay JomPay Bill</a></p>
                        </span>
                            <div class="d-grid gap-2">
                                <br>
                                <button class="btn btn-secondary dary waves-effect waves-light" type="button" @click="submitFile"> Submit </button>
                            </div>
                        
                    </div>

                    <div class="spinner-border text-success" role="status" v-if="loadingupload">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div v-if="messageBag">
                        <div class="alert alert-warning alert-border-left alert-dismissible fade show" role="alert">
                            <i class="ri-alert-line me-3 align-middle fs-16"></i><strong> {{ messageBag }}</strong>
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>